<!-- CtrlKeyMonitor:  Determine when the Ctrl/Alt/Shift keys are down render into a named scoped slot when keys are pressed -->
<script lang="ts" setup>
    import { ref } from 'vue';
    import KeyMonitor from './KeyMonitor.vue'

    const ctrlKeyPressed = ref<boolean>(false);
    const altKeyPressed = ref<boolean>(false);
    const shiftKeyPressed = ref<boolean>(false);

    function setKeyStates(evt: KeyboardEvent)
    {
        ctrlKeyPressed.value = evt.ctrlKey; 
        altKeyPressed.value = evt.altKey; 
        shiftKeyPressed.value = evt.shiftKey;
    }
</script>
<template>
    <KeyMonitor @keydown="setKeyStates" @keyup="setKeyStates" />
    
    <slot name="keydown" :ctrl="ctrlKeyPressed" :alt="altKeyPressed" :shift="shiftKeyPressed" />
</template>